import React from "react";

const PUBLIC_URL = process.env.PUBLIC_URL || "";
const ABRUZZO_LOGO = `${PUBLIC_URL}/logo-abruzzo-made-in-nature.jpg`;
const EU_FLAG = `${PUBLIC_URL}/european-union-flag.svg`;
const ABRUZZO_SITE = "https://www.regione.abruzzo.it/";
const EU_SITE = "https://enlargement.ec.europa.eu/funding-technical-assistance/twinning_en";

export default function RegionEuLogos({
  className = "",
  abruzzoClassName = "w-28 sm:w-32 max-w-full",
  euClassName = "w-14 sm:w-16",
  showEuCaption = false,
  euCaption = "Sezione Europa – Rete dei Comuni Partner",
  /** @deprecated Usare <EuropaLegalFooter /> sotto i loghi */
  euLegalNote = "",
  testIdPrefix = "regional",
  showAbruzzo = true,
  showEu = true,
}) {
  const ariaLabel = showAbruzzo && showEu
    ? "Loghi Regione Abruzzo e Unione Europea"
    : showEu
      ? "Logo Unione Europea"
      : "Logo Regione Abruzzo";

  return (
    <div
      className={`flex flex-wrap items-center justify-center gap-3 sm:gap-4 ${className}`}
      aria-label={ariaLabel}
    >
      {showAbruzzo && (
        <a
          href={ABRUZZO_SITE}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Apri il sito ufficiale della Regione Abruzzo"
          title="Sito ufficiale Regione Abruzzo"
          className="inline-flex shrink max-w-full rounded-sm focus:outline-none focus:ring-2 focus:ring-terracotta focus:ring-offset-2"
        >
          <img
            src={ABRUZZO_LOGO}
            alt="Regione Abruzzo - Made in Nature, Made in Italy"
            width="600"
            height="243"
            data-testid={`${testIdPrefix}-logo-abruzzo`}
            className={`h-auto shrink object-contain ${abruzzoClassName}`}
            loading="lazy"
            decoding="async"
          />
        </a>
      )}
      {showEu && (
        <span className="inline-flex max-w-[120px] shrink-0 flex-col items-center text-center">
          <a
            href={EU_SITE}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Apri la pagina Twinning della Commissione europea"
            title="Pagina Twinning della Commissione europea"
            className="inline-flex shrink-0 rounded-sm focus:outline-none focus:ring-2 focus:ring-terracotta focus:ring-offset-2"
          >
            <img
              src={EU_FLAG}
              alt="Bandiera dell'Unione Europea"
              width="810"
              height="540"
              data-testid={`${testIdPrefix}-logo-eu`}
              className={`block aspect-[3/2] h-auto max-w-full shrink-0 rounded-sm shadow-sm object-contain ${euClassName}`}
              loading="lazy"
              decoding="async"
            />
          </a>
          {showEuCaption && (
            <span className="mt-1 block text-[7px] leading-tight text-ink2/75">
              <span className="block font-mono uppercase tracking-[0.1em] text-terracotta">
                {euCaption}
              </span>
              {euLegalNote && (
                <span className="mt-0.5 block text-[6px] leading-tight text-ink2/60">
                  {euLegalNote}
                </span>
              )}
            </span>
          )}
        </span>
      )}
    </div>
  );
}
